export const PROXIMITY_THRESHOLD_METERS = 30;
export const INFRA_RADIUS_METERS = 50;

export const toRadians = (value) => (value * Math.PI) / 180;

export const haversineDistanceMeters = (pointA, pointB) => {
  const earthRadius = 6371000;

  const lat1 = toRadians(pointA.latitude);
  const lat2 = toRadians(pointB.latitude);
  const dLat = toRadians(pointB.latitude - pointA.latitude);
  const dLon = toRadians(pointB.longitude - pointA.longitude);

  const sinLat = Math.sin(dLat / 2);
  const sinLon = Math.sin(dLon / 2);
  const a = sinLat * sinLat + Math.cos(lat1) * Math.cos(lat2) * sinLon * sinLon;
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return earthRadius * c;
};

export const parseCoordinatesInput = (rawValue) => {
  const value = String(rawValue || '').trim();
  if (!value) {
    return {
      isValid: false,
      error: 'Введите координаты в формате latitude, longitude'
    };
  }

  const parts = value.split(',').map((part) => part.trim());
  if (parts.length !== 2 || !parts[0] || !parts[1]) {
    return {
      isValid: false,
      error: 'Используйте формат latitude, longitude'
    };
  }

  const latitude = Number(parts[0]);
  const longitude = Number(parts[1]);

  if (!Number.isFinite(latitude) || !Number.isFinite(longitude)) {
    return {
      isValid: false,
      error: 'Координаты должны быть числами'
    };
  }

  return {
    isValid: true,
    latitude,
    longitude
  };
};

export const validatePointPayload = ({ name, latitude, longitude }) => {
  const errors = {};

  if (!String(name || '').trim()) {
    errors.name = 'Название точки обязательно';
  }

  const lat = Number(latitude);
  if (!Number.isFinite(lat) || lat < -90 || lat > 90) {
    errors.latitude = 'Широта должна быть в диапазоне от -90 до 90';
  }

  const lon = Number(longitude);
  if (!Number.isFinite(lon) || lon < -180 || lon > 180) {
    errors.longitude = 'Долгота должна быть в диапазоне от -180 до 180';
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors
  };
};

export const buildDistancePairs = (points) => {
  const pairs = [];

  for (let i = 0; i < points.length; i += 1) {
    for (let j = i + 1; j < points.length; j += 1) {
      const first = points[i];
      const second = points[j];
      const distance = haversineDistanceMeters(first, second);

      pairs.push({
        id: `${first.pointKey}__${second.pointKey}`,
        first,
        second,
        distance
      });
    }
  }

  return pairs;
};

export const getLatestPointKey = (points) => {
  if (!points.length) return null;

  const latest = points.reduce((acc, point) => {
    if (!acc) return point;
    return point.sortTimestamp > acc.sortTimestamp ? point : acc;
  }, null);

  return latest?.pointKey || null;
};

export const buildPointFlags = ({ points, pairs }) => {
  const byKey = {};

  points.forEach((point) => {
    const distanceMeters = point.infrastructure?.distanceMeters;
    byKey[point.pointKey] = {
      proximityViolation: false,
      infrastructureViolation:
        point.infrastructure?.status === 'found' && Number.isFinite(distanceMeters) && distanceMeters < INFRA_RADIUS_METERS
    };
  });

  pairs.forEach((pair) => {
    if (pair.distance >= PROXIMITY_THRESHOLD_METERS) {
      return;
    }

    if (byKey[pair.first.pointKey]) {
      byKey[pair.first.pointKey].proximityViolation = true;
    }

    if (byKey[pair.second.pointKey]) {
      byKey[pair.second.pointKey].proximityViolation = true;
    }
  });

  return byKey;
};
